var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GenericChart',_vm._b({staticClass:"make-a-copy",attrs:{"request-status":_vm.requestStatus,"title":_vm.title,"items":_vm.items,"item-id":_vm.itemId,"has-info":false},on:{"reload":_vm.getData}},'GenericChart',_vm.$attrs,false)),(_vm.hasItems)?_c('v-data-table',{staticClass:"table-truncate",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":_vm.itemsPerPage,"loading":_vm.inputLoading},scopedSlots:_vm._u([{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.botId))])]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.name))])]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.total))])]}},{key:"item.failed",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.failed))])]}},{key:"item.received",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.received))])]}},{key:"item.read",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.read))])]}},{key:"item.campaignStatus",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.campaignStatus))])]}},{key:"item.created",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.created))])]}}],null,true)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }